import { DeviceResponse } from 'APP/wsApi/wsAppApi/types/device/device_response_pb';

export enum RewardProgressInfoRewardEnum {
  UsernameBadge1 = 'USERNAME_BADGE_1',
  ExclusiveBackground1 = 'EXCLUSIVE_BACKGROUND_1',
  ExclusiveStickerPack1 = 'EXCLUSIVE_STICKER_PACK_1',
}

export enum RewardStatusEnum {
  Acknowledged = 'ACKNOWLEDGED',
  Achieved = 'ACHIEVED',
}

export enum PrivacyValue {
  Nobody = 'NONE',
  Anyone = 'ANYONE',
  Contacts = 'CONTACTS',
}

export interface IPrivacySettings {
  showPhoneNumber: PrivacyValue;
  showAvatar: PrivacyValue;
  addToGroup: PrivacyValue;
  addToPublic: PrivacyValue;
  callMe: PrivacyValue;
  showLastSeen: PrivacyValue;
  searchMe: PrivacyValue;
  sendVoiceMessage: PrivacyValue;
  updateTs?: number;
}

export interface IUpdateUserDisplayDataB2B {
  avatarUrl?: string;
  nickName: string;
  phone?: string;
  position?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  displayName: string;
}

export type IValidateNickNameResponse = {
  isAvailable: boolean;
  isValid: boolean;
  validationViolations: Array<string>;
};

export enum PlatformTypesEnum {
  WEB = 'WEB',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  HUAWEI = 'HUAWEI',
  DESKTOP = 'DESKTOP',
  OTHER = 'OTHER',
}

export interface IUserDevice {
  deviceId: string;
  platform: PlatformTypesEnum;
  device: string;
  osName: string;
  osVersion: string;
  appVersion: string;
  status?: DeviceStatus;
  statusAt?: string;
}

export type IDeviceResponse = DeviceResponse;

export interface IUserDevicesItem {
  id: string;
  device: IUserDevice;
  createdAtTs: number;
  lastActivityTs: number;
}

export type IUserDevices = Array<IUserDevicesItem>;

export interface IUserDevicesResponse {
  currentDevice: IUserDevicesItem;
  devices: IUserDevices;
}

export interface ITerminateDevicesParams {
  deviceIds: Array<string>;
}

export type ITerminateDevicesResponse = Array<string>;

export enum DeviceStatus {
  Pending = 'pending',
  Trusted = 'trusted',
  Blocked = 'blocked',
  Unlocked = 'unlocked',
  Deleted = 'deleted',
}
